// Наследуем свойства и методы базового объекта
var FolderModel = BaseObjectModel.extend({
  className: "FolderModel"
});